<template>
  <div class="full_box mobile-i18n-page">
    <custom-tabs
      activeTab="swFollow"
      :tabs="tabs"
      :hasBack="false"
      color="#ffffff"
      pb="18px"
    >
    </custom-tabs>
    <div class="search_box">
      <!-- 搜索料号、名称 -->
      <van-search
        v-model="searchKeyword"
        :placeholder="$t('common.searchPlaceholder')"
        shape="round"
        @search="onSearch"
        @clear="onSearch"
      >
        <template #right-icon>
          <van-icon name="search" @click="onSearch" />
        </template>
      </van-search>
    </div>

    <div class="follow_box">
      <div class="same follow_new">
        <div class="title">
          <!-- 新的抢单信息 -->
          <div class="title_left" v-if="hasNewClue">
            {{ $t("workflowFeedback.newClaimInformation") }}
          </div>
          <!-- 暂无可抢单信息 -->
          <div class="title_no_left" v-else>
            {{ $t("workflowFeedback.noClaimInformation") }}
          </div>
          <!-- 更多 -->
          <div
            class="title_right"
            @click="$router.push('/follow/swPendingFollow')"
          >
            {{ $t("companyInfo.more") }}
            <van-icon name="arrow" />
          </div>
        </div>
        <template v-if="hasNewClue">
          <SWFollowListItem
            v-for="item in newClueList"
            :key="item.id"
            :item="item"
            type="other"
            @sw-get-follow="acceptPreOrder"
            @sw-block-follow="blockPreOrder"
          ></SWFollowListItem>
        </template>
      </div>

      <div v-if="preOrderList && preOrderList.length > 0" class="follow_list">
        <SWFollowListItem
          v-for="item in preOrderList"
          :key="item.id"
          :item="item"
          class="same"
        ></SWFollowListItem>
      </div>
      <div v-else>
        <!-- 暂无数据 -->
        <van-empty :description="$t('business.noData')" />
      </div>
    </div>
  </div>
</template>

<script>
import CustomTabs from "@/components/CustomTabs.vue";
import CountBox from "@/components/CountBox.vue";
import SWFollowListItem from "@/components/SWFollowListItem.vue";
import { getUserInfoDetail } from "@/api/user";
import { getMyFollowList } from "@/api/MyFollow";
import {
  swPendingFollowList,
  blockBizOpporMsg,
  followUp,
} from "@/api/bizOppor";

export default {
  name: "SW_TPR",
  components: {
    SWFollowListItem,
    CountBox,
    CustomTabs,
  },
  data() {
    return {
      searchKeyword: "",
      //状态1已提交2谈判人已接单3商务已接单4已生成合同5已确认金额6买家已支付7货主已支付9交易完成

      active: 0,
      params: {
        pageSize: 10,
        pageNum: 1,
        status: null,
      },
      isEdit: false,
      userInfo: {
        businessType: null,
      },
      preOrderList: [],
      preOrderTotal: 0,

      clueFollowList: [],
      clueFollowTotal: 0,
      preOrderFollowList: [],
      preOrderFollowTotal: 0,
      hasNewClue: false, //是否有新订单
    };
  },
  computed: {
    tabList() {
      return [
        // 全部
        { title: this.$t("business.all"), status: null, name: "all" },
        // { title: "待处理", status: 3, name: "wait" },
        // { title: "交易中", status: 4, name: "jy" },
        // { title: "待支付", status: 5, name: "zf" },
        // { title: "交易完成", status: 9, name: "wc" },
        // 商务跟单
      ];
    },
    tabs() {
      return [
        // 商务跟单
        { title: this.$t("orderFollow.businessTracking"), name: "swFollow" },
      ];
    },
  },

  created() {
    this.getUserInfo();
    this.pendingSWFollowPreOrderList();
  },
  methods: {
    onSearch() {
      this.params.allSearch = this.searchKeyword;
      this.getMySwFollowPreOrderList();
    },
    // 查看是否有新订单
    async pendingSWFollowPreOrderList() {
      swPendingFollowList().then((resp) => {
        this.hasNewClue = resp.rows.length > 0;
        var item = resp.rows?.[0];
        if (!item) return;
        if (item.clueType == 1) {
          item.peopleList = [
            {
              text: "货主",
              name: item.ownerName || "",
              phone: item.ownerMobile || "",
              wx: item.ownerWx || "",
              avatar: item.ownerAvatar || "",
            },
            {
              text: "采购谈判人",
              name: item.sellerNegotiatorName || "",
              phone: item.sellerNegotiatorMobile || "",
              wx: item.sellerNegotiatortWx || "",
              avatar: item.sellerNegotiatorAvatar || "",
            },
          ];
        } else {
          item.peopleList = [
            {
              text: "采购商务",
              name: item.sellerBusinessName || "",
              phone: item.sellerBusinessMobile || "",
              wx: item.sellerBusinessWx || "",
              avatar: item.sellerBusinessAvatar || "",
            },
            {
              text: "销售谈判人",
              name: item.buyerNegotiatorName || "",
              phone: item.buyerNegotiatorMobile || "",
              wx: item.buyerNegotiatorWx || "",
              avatar: item.buyerNegotiatorAvatar || "",
            },
          ];
        }
        this.newClueList = [item];
      });
    },
    // 抢单
    acceptPreOrder(order) {
      // console.log("=======订购单跟进抢单============", order);
      followUp({ id: order.id, identity: "20" }).then((resp) => {
        // console.log("======抢单提交结果======", resp);
        if (resp.code == 200) {
          this.$router.push({
            path: "/follow/getFollowSuccess",
            query: {
              // model : 1:卖 2买
              model: order.model,
            },
          });
        } else if (resp.code == 500) {
          Toast(resp.msg);
        }
      });
    },
    // 屏蔽
    blockPreOrder(order) {
      Dialog.confirm({
        // 提示
        title: this.$t("companyInfo.confirm"),
        // 确定屏蔽该条信息吗？
        message: this.$t("orderFollow.hideConfirm"),
        // 确定
        confirmButtonText: this.$t("auth.confirm"),
        // 取消
        cancelButtonText: this.$t("business.cancel"),
        theme: "warning",
      })
        .then(() => {
          // 点击确定后执行屏蔽操作
          blockBizOpporMsg({
            bizMsgId: order.id,
            blockType: 20, // 10-谈判人屏蔽，20-商务屏蔽
          }).then((resp) => {
            if (resp.code === 200) {
              // 屏蔽成功提示
              Toast.success({
                // 屏蔽成功
                message: this.$t("orderFollow.hidden"),
                duration: 2000, // 提示显示时长
                onClose: () => {
                  // 提示关闭后刷新列表
                  this.pendingSWFollowPreOrderList();
                },
              });
            } else if (resp.code === 500) {
              // 错误提示
              Toast.fail(resp.msg);
            }
          });
        })
        .catch(() => {
          // 点击取消时不做操作（可选：可添加取消后的逻辑）
        });
    },
    onTab(index) {
      this.active = index;
      this.params.status = this.tabList[index].status;
      this.getMySwFollowPreOrderList();
    },
    async getUserInfo() {
      const response = await getUserInfoDetail();
      console.log("========返回userinfo======", response);
      if (response.code === 200) {
        this.userInfo = response.data.userInfo;
        this.getMySwFollowPreOrderList();
      }
    },
    async getMySwFollowPreOrderList() {
      getMyFollowList(this.params).then((resp) => {
        console.log("=========返回的列表===========", resp.rows);
        this.preOrderList = resp.rows;
        this.preOrderTotal = resp.total;
        if (this.preOrderList.length == 0) return;
        this.preOrderList.forEach((item) => {
          this.handleData(item);
        });
      });
    },
    handleData(item) {
      // type 10-线索跟单 20-商品跟单 30-交易跟单
      // if (item.type == 10) {
      //   item.peopleList = [
      //     {
      //       text: `${item.model == 1 ? "货主" : "买家"}`,
      //       name: item.ownerName || "",
      //       phone: item.ownerMobile || "",
      //       wx: item.ownerWx || "",
      //       avatar: item.ownerAvatar || "",
      //     },
      //     {
      //       text: `${item.model == 1 ? "货主信息提供人" : "买家信息提供人"}`,
      //       name: item.contactName || "",
      //       phone: item.contactMobile || "",
      //       wx: item.contactWx || "",
      //       avatar: item.contactAvatar || "",
      //     },
      //   ];
      // } else
      if (item.type == 20) {
        // model 1 货主 2 买家
        if (item.model == 1) {
          // 采购商务接单
          item.peopleList = [
            {
              text: "货主",
              name: item.ownerName || "",
              phone: item.ownerMobile || "",
              wx: item.ownerWx || "",
              avatar: item.ownerAvatar || "",
            },
            {
              text: "采购谈判人",
              name: item.sellerNegotiatorName || "",
              phone: item.sellerNegotiatorMobile || "",
              wx: item.sellerNegotiatorWx || "",
              avatar: item.sellerNegotiatorAvatar || "",
            },
          ];
        } else if (item.model == 2) {
          // 目前没有这种情况
          item.peopleList = [];
        }
      } else if (item.type == 30) {
        // model 1 货主 2 买家
        if (item.model == 1) {
          // 销售商务接单
          if (item.buyerBusinessName) {
            item.peopleList = [
              {
                text: "销售商务",
                name: item.buyerBusinessName || "",
                phone: item.buyerBusinessMobile || "",
                wx: item.buyerBusinessWx || "",
                avatar: item.buyerBusinessAvatar || "",
              },
              {
                text: "验货人",
                name: item.inspectorUserName || "",
                phone: item.inspectorUserMobile || "",
                wx: item.inspectorUserWx || "",
                avatar: item.inspectorUserAvatar || "",
              },
            ];
          }
          // 销售谈判人接单
          else if (item.buyerNegotiatorName) {
            item.peopleList = [
              {
                text: "采购谈判人",
                name: item.sellerNegotiatorName || "",
                phone: item.sellerNegotiatorMobile || "",
                wx: item.sellerNegotiatorWx || "",
                avatar: item.sellerNegotiatorAvatar || "",
              },
              {
                text: "销售谈判人",
                name: item.buyerNegotiatorName || "",
                phone: item.buyerNegotiatorMobile || "",
                wx: item.buyerNegotiatorWx || "",
                avatar: item.buyerNegotiatorAvatar || "",
              },
            ];
          }
        } else if (item.model == 2) {
          // 销售商务接单
          if (item.sellerBusinessName) {
            item.peopleList = [
              {
                text: "买家",
                name: item.ownerName || "",
                phone: item.ownerMobile || "",
                wx: item.ownerWx || "",
                avatar: item.ownerAvatar || "",
              },
              {
                text: "采购商务",
                name: item.sellerBusinessName || "",
                phone: item.sellerBusinessMobile || "",
                wx: item.sellerBusinessWx || "",
                avatar: item.sellerBusinessAvatar || "",
              },
              {
                text: "采购谈判人",
                name: item.contactName || "",
                phone: item.contactMobile || "",
                wx: item.contactWx || "",
                avatar: item.contactAvatar || "",
              },
              {
                text: "销售谈判人",
                name: item.buyerNegotiatorName || "",
                phone: item.buyerNegotiatorMobile || "",
                wx: item.buyerNegotiatorWx || "",
                avatar: item.buyerNegotiatorAvatar || "",
              },
            ];
          }
        }
      }
    },
    viewDetail(item) {
      console.log("=======查看详情============", item);
      this.$router.push("/preOrderDetail/" + item.id);
    },
  },
  watch: {},
};
</script>

<style lang="less" scoped>
// 主题 padding
.full_box {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  .search_box {
    background-color: #fff;
    /* 核心：清除Vant2搜索框左侧默认的icon占位，让输入区左对齐 */
    /deep/ .van-field__left-icon {
      display: none !important;
    }
  }

  .follow_box {
    margin: 8px 12px 20px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    flex: 1;
    overflow-y: scroll;
    padding-bottom: @bottom-bar-height;

    .same {
      padding: 15px 12px 18px;
      background-color: #fff;
      border-radius: 12px;
    }

    .follow_new {
      display: flex;
      flex-direction: column;
      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title_left,
        .title_no_left {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #3b3b3b;
          font-size: 16px;
        }

        .title_left::before {
          content: ""; //必须设置content为空，否则伪元素不显示
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #f95348;
        }
        .title_right {
          display: flex;
          align-items: center;
          gap: 8px;
          color: #4286f5;
          font-size: 16px;
        }
      }
    }

    .follow_list {
      display: flex;
      flex-direction: column;
      gap: 8px;

      .follow_item {
      }
    }
  }
}
</style>
